import { useEffect } from 'react';
import { useReceivingFeed } from 'hooks/useReceivingFeed';

export const useRemoteAudio = (mid: string) => {
  const { control } = useReceivingFeed();

  useEffect(() => {
    control.attachAudio(mid);

    return () => {
      control.detachFromElement(mid);
    };
  }, [mid, control]);
};
